import { GetCostBreakdownResponseModel } from '../../services/quote.interfaces';
import { pushToDataLayer } from '../pushToDataLayer/pushToDataLayer.util';
import { LineItem } from '../../services/quote.interfaces';
interface ExtraFields {
  [key: string]: string | any;
}
const getValue = (valueToGet: any): string => {
  return valueToGet || 'N/A';
};
const getLineItemValue = (
  objectToSearch: LineItem[] | undefined,
  keyToSearchFor: string
) => {
  if (!objectToSearch) return 'N/A';
  const objectWithMatchingKey: LineItem | undefined = objectToSearch.find(
    (lineItem: LineItem) => lineItem.name === keyToSearchFor
  );
  if (objectWithMatchingKey) {
    return `${objectWithMatchingKey.amount || 'N/A'}`;
  } else {
    return 'N/A';
  }
};
export const postQuoteOverviewToDataLayer = (
  eventName: string,
  quoteReference: string | undefined,
  trackingReference: string | undefined,
  costBreakdown: GetCostBreakdownResponseModel | null,
  extraFields: ExtraFields | null = null
): void => {
  if (quoteReference && trackingReference && costBreakdown) {
    const data = {
      funnel_journey: getValue(costBreakdown?.transactionType),
      quote_reference_number: getValue(quoteReference),
      tracking_reference: getValue(trackingReference),
      grand_total: getValue(costBreakdown?.headlineInformation?.grandTotal),
      buy_value: getValue(costBreakdown?.headlineInformation?.buyPrice),
      sell_value: getValue(costBreakdown?.headlineInformation?.sellPrice),
      remortgage_value: getValue(
        costBreakdown?.headlineInformation?.remortgagePrice
      ),
      our_costs: [
        {
          mhm_selling_costs: {
            selling_legal_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown
                ?.sellLineItems,
              'Legal fee'
            ),
            selling_leasehold_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown
                ?.sellLineItems,
              'Leasehold fee'
            ),
            selling_mortgage_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown
                ?.sellLineItems,
              'Mortgage fee'
            ),
            selling_file_opening_fe: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown
                ?.sellLineItems,
              'File opening fee'
            ),
          },
        },
        {
          mhm_buying_costs: {
            buying_legal_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown?.buyLineItems,
              'Legal fee'
            ),
            buying_leasehold_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown?.buyLineItems,
              'Leasehold fee'
            ),
            buying_mortgage_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown?.buyLineItems,
              'Mortgage fee'
            ),
            buying_stampduty_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown?.buyLineItems,
              'Land Transaction Tax fee'
            ),
            buying_file_opening_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown?.buyLineItems,
              'File opening fee'
            ),
          },
        },
        {
          mhm_remortgaging_costs: {
            remortgage_legal_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.conveyancingBreakdown
                ?.remortgageLineItems,
              'Legal fee'
            ),
          },
        },
        {
          mhm_subtotal: getValue(
            costBreakdown?.costBreakdown?.conveyancingBreakdown?.subtotal
          ),
          mhm_subtotal_discounted: getValue(
            costBreakdown?.costBreakdown?.conveyancingBreakdown
              ?.subtotalDiscountedAmount
          ),
        },
      ],
      cost_third: [
        {
          third_selling_costs: {
            third_selling_official_copies: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.sellLineItems,
              'Official Copies (up to)'
            ),
            third_selling_vat: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.sellLineItems,
              'VAT'
            ),
          },
        },
        {
          third_buying_costs: {
            third_buying_search_pack: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.buyLineItems,
              'Search Pack'
            ),
            third_buying_land_registry_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.buyLineItems,
              'Land Registry fee'
            ),
            third_buying_stampduty_tax: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.buyLineItems,
              'Land Transaction Tax'
            ),
            third_buying_land_registry_searches: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.buyLineItems,
              'Land Registry Searches'
            ),
            third_buying_vat: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.buyLineItems,
              'VAT'
            ),
          },
        },
        {
          third_remortgaging_costs: {
            third_remortgaging_land_registry_fee: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.remortgageLineItems,
              'Land Registry Fee'
            ),
            third_remortgaging_official_copies: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.remortgageLineItems,
              'Official Copies'
            ),
            third_remortgaging_land_registry_searches: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.remortgageLineItems,
              'Arranging Search Indemnity (inc. VAT & premium)'
            ),
            third_remortgaging_vat: getLineItemValue(
              costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
                ?.remortgageLineItems,
              'VAT'
            ),
          },
        },
        {
          third_subtotal: getValue(
            costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown?.subtotal
          ),
          third_subtotal_discounted: getValue(
            costBreakdown?.costBreakdown?.thirdPartyCostsBreakdown
              ?.subtotalDiscountedAmount
          ),
        },
        extraFields && extraFields,
      ],
    };

    pushToDataLayer({
      event: eventName,
      data: { ...data },
    });
  }
};
